import CryptoJS from 'crypto-js';
// Example: entire clientId as the key:
const CLIENT_ID = process.env.REACT_APP_CRYPTO_HASH; 

export function encryptAES(plainText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  // last 16 characters for IV
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString(); // Base64
}
export function decryptAES(encryptedText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  console.log("decrypted", decrypted.toString(CryptoJS.enc.Utf8))
  return decrypted.toString(CryptoJS.enc.Utf8);
}